import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export const checkAdminWhitelist = async (email: string): Promise<boolean> => {
    if (!email) return false;

    try {
        const ref = doc(db, "admin_whitelist", email);
        const snap = await getDoc(ref);

        return snap.exists() && snap.data()?.enabled === true;
    } catch (error) {
        console.error("Error checking admin whitelist:", error);
        return false;
    }
};
